import React, { useEffect } from 'react';
import '../styles/Pages.css';

const BirutaHamburgueria = () => {
    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/56599b160757857.63b9ffee1fce1.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/bd0798160757857.63b9ffee2ffb2.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/ab908e160757857.63b9ffee19428.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/24f1d9160757857.63b9ffee1b646.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/bd2cc7160757857.63b9ffee2b5f4.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/a46964160757857.63b9ffee222b8.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d08233160757857.63b9ffee1a4c0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d88373160757857.63b9ffee2f044.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/1a2568160757857.63b9ffee30f93.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3aa1db160757857.63b9ffee1d972.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/22942b160757857.63b9ffee25be3.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/f0a5a2160757857.63c951dfaa708.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/83e9f8160757857.63b9ffee210ba.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/75403f160757857.63b9ffee1c749.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/8c9955160757857.63b9ffee2de8e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/07a74f160757857.63b9ffee29300.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d529b3160757857.63b9ffee2497e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/95c291160757857.63c951dfaca3c.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/b34524160757857.63b9ffee23714.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/cc8206160757857.63b9ffee26dec.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3f56bf160757857.63b9ffee1ea4f.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/52e25e160757857.63c951dfabca4.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/c27b34160757857.63b9ffee27f0a.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/52b1e6160757857.63b9ffee2a3c3.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/0b10cf160757857.63b9ffee2ca9c.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d775a2160757857.63b9ffee18241.png'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };
    }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Biruta Hamburgueria</h1>
                    <p className="subtitle"></p>
                </div>
                <div className="pages-right">
                    <p className="description">
                        A criação da identidade visual da hamburgueria Biruta é um trabalho fictício, que tem a finalidade de transmitir diversão e alegria através das cores quentes e vivas, além de passar uma imagem de sabor e apetite.<br />
                        Biruta produz seus hamburguers para todo o tipo de pessoas e classes, portanto é necessário que pareça ser bastante acessível
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Centro de Convivência Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default BirutaHamburgueria;
